import { render, staticRenderFns } from "./skeleton_loader.vue?vue&type=template&id=e44624ce"
import script from "./skeleton_loader.vue?vue&type=script&lang=js"
export * from "./skeleton_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports